// src/components/Header.js
import { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-[var(--color-surface)] border-b border-[var(--color-mint-200)]">
      <div className="container-pad flex items-center justify-between py-3">
        {/* Brand */}
        <a href="/home" className="text-[var(--color-ink)]">
          <span className="text-lg font-bold"> Ekalvya Ashram School </span>
          <div className="text-sm"> भटके विमुक्त जाती व आदिवासी ज्ञानपीठ </div>
        </a>

        {/* Desktop nav (md and up) */}
        <nav className="hidden md:flex items-center gap-8">
          <a className="text-[var(--color-ink)] text-sm font-medium" href="/">
            Home
          </a>
          <a className="text-[var(--color-ink)] text-sm font-medium" href="/about">
            About
          </a>
          <a className="text-[var(--color-ink)] text-sm font-medium" href="/gallery">
            Gallery
          </a>
          <a className="text-[var(--color-ink)] text-sm font-medium" href="/contact">
            Contact
          </a>
          <a className="text-[var(--color-ink)] text-sm font-medium" href="/journey">
            Journey
          </a>
          <a className="text-[var(--color-ink)] text-sm font-medium" href="/blogs">
            Activity
          </a>
          <a
            href="/contact"
            className="hidden lg:inline-flex btn-primary h-9 px-4"
          >
            Donate
          </a>
        </nav>

        {/* Hamburger (ONLY mobile) */}
        <button
          className="md:hidden inline-flex items-center justify-center size-10 rounded-lg border border-[var(--color-mint-200)]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Open menu"
          aria-expanded={open}
        >
          <span className="sr-only">Menu</span>
          {/* 3 bars */}
          <div className="space-y-1.5">
            <span className={`block h-0.5 w-5 bg-[var(--color-ink)] transition ${open ? "translate-y-2 rotate-45" : ""}`}/>
            <span className={`block h-0.5 w-5 bg-[var(--color-ink)] transition ${open ? "opacity-0" : ""}`}/>
            <span className={`block h-0.5 w-5 bg-[var(--color-ink)] transition ${open ? "-translate-y-2 -rotate-45" : ""}`}/>
          </div>
        </button>
      </div>

      {/* Mobile dropdown (ONLY mobile) */}
      <div
        className={`md:hidden overflow-hidden transition-[max-height] duration-300 ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <nav className="container-pad py-2 flex flex-col gap-2">
          <a className="py-2 text-[var(--color-ink)] text-sm font-medium" href="/" onClick={() => setOpen(false)}>
            Home
          </a>
          <a className="py-2 text-[var(--color-ink)] text-sm font-medium" href="/about" onClick={() => setOpen(false)}>
            About
          </a>
          <a className="py-2 text-[var(--color-ink)] text-sm font-medium" href="/gallery" onClick={() => setOpen(false)}>
            Gallery
          </a>
          <a className="py-2 text-[var(--color-ink)] text-sm font-medium" href="/contact" onClick={() => setOpen(false)}>
            Contact
          </a>
          <a className="py-2 text-[var(--color-ink)] text-sm font-medium" href="/journey" onClick={() => setOpen(false)}>
            Journey
          </a>
          <a className="py-2 text-[var(--color-ink)] text-sm font-medium" href="/blogs" onClick={() => setOpen(false)}>
            Activity
          </a>
          <a
            href="/contact"
            className="mt-1 btn-primary h-10 justify-center"
            onClick={() => setOpen(false)}
          >
            Donate
          </a>
        </nav>
      </div>
    </header>
  );
}
